export default __webpack_public_path__ + "static/media/199393877200fb2fd625497d26cdd30d1600817108997.1fbefda2.webp";